import { gqlClient } from 'services/api/gql/gqlClient';
import { ProductComparison } from 'constants/gql/queries/productComparison/productComparison.gql';
import localeUtils from 'utils/LanguageLocale';
import { FULFILLMENT_TYPES } from 'constants/ItemSubstitution';

const getProductComparison = async (requestParams = {}) => {
    Sephora.logger.verbose('getProductComparison called with params:', requestParams);

    const locale = `${localeUtils.getCurrentLanguage().toUpperCase()}_${localeUtils.getCurrentCountry()}`;
    const currentDateTime = new Date().toISOString();
    const isUS = localeUtils.isUS();

    try {
        const locationsByFulfillmentType = [{ fulfillmentType: FULFILLMENT_TYPES.SHIP, locations: [] }];

        if (requestParams.preferredStore) {
            locationsByFulfillmentType.push({
                fulfillmentType: FULFILLMENT_TYPES.PICK,
                locations: [requestParams.preferredStore]
            });
        }

        if (requestParams.preferredZipCode) {
            locationsByFulfillmentType.push({
                fulfillmentType: FULFILLMENT_TYPES.SAMEDAY,
                locations: [requestParams.preferredZipCode]
            });
        }

        const options = {
            query: ProductComparison,
            operationName: 'ProductComparison',
            variables: {
                skuIds: requestParams.skuIds || [],
                locale: locale,
                quantity: 3,
                availbility: {
                    currentDateTime,
                    evaluateNetworkAvail: true,
                    requestOrigin: 'PLP_COMPARE_WEB',
                    evaluateCapacity: false,
                    sellingChannel: isUS ? 'SEPHORAUS' : 'SEPHORACA',
                    locationsByFulfillmentType,
                    products: requestParams.skuIds || []
                }
            },
            allowPartialResponse: true
        };

        const result = await gqlClient.query(options);

        return result;
    } catch (error) {
        Sephora.logger.error('Error in getProductComparison:', error);
        throw error;
    }
};

export default getProductComparison;
